"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR = exports.TESTS = exports.ROOT = void 0;
var ROOT = '/';
exports.ROOT = ROOT;
var TESTS = '/tests';
exports.TESTS = TESTS;
var ERROR = '/error';
exports.ERROR = ERROR;


//////////////////
// WEBPACK FOOTER
// ./js/constants/Paths.js
// module id = 32
// module chunks = 0